import { Paper } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import classNames from 'classnames';
import React from 'react';
import styles from '../styles.module.scss';
import { QaItem } from '../types';
import { formatSiblingDetailLine } from '../utils';

const QaTable = ({ data, query }: { data: QaItem[]; query: string }) => (
  <TableContainer component={Paper}>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell width="4%">#</TableCell>
          <TableCell width="32%">Question</TableCell>
          <TableCell width="32%">Answer</TableCell>
          <TableCell width="32%">Available options</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.length > 0 ? (
          data.map(qaItem => (
            <TableRow
              className={classNames(
                getIsRowHighlighted(qaItem, query) && styles.Highlighted,
              )}
              key={qaItem.idx}
            >
              <TableCell>{qaItem.idx}</TableCell>
              <TableCell>{qaItem.question}</TableCell>
              <TableCell>
                {qaItem.answer}
                {qaItem.siblings && qaItem.siblings.length > 0 && (
                  <ul className={styles.List}>
                    {qaItem.siblings.map((sibling, i) => (
                      <li key={i}>{formatSiblingDetailLine(sibling, i)}</li>
                    ))}
                  </ul>
                )}
              </TableCell>
              <TableCell>
                {qaItem.availableOptions &&
                qaItem.availableOptions.length > 0 ? (
                  <ul className={styles.List}>
                    {qaItem.availableOptions.map((option, idx) => (
                      <li key={idx}>{option}</li>
                    ))}
                  </ul>
                ) : (
                  'N/A'
                )}
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={5} align="center">
              No data found
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

const getIsRowHighlighted = (qaItem: QaItem, query: string) => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return false;

  const inQuestion = qaItem.question
    .trim()
    .toLowerCase()
    .includes(normalizedQuery);
  const inAnswer = qaItem.answer.trim().toLowerCase().includes(normalizedQuery);

  const inOptions =
    qaItem.availableOptions?.some(opt =>
      opt.trim().toLowerCase().includes(normalizedQuery),
    ) ?? false;

  return inQuestion || inAnswer || inOptions;
};

export default QaTable;
